/**
 * Query Provider
 *
 * TanStack Query provider with preconfigured client and devtools.
 *
 * @layer app
 * @segment providers
 * @added DOC-0100 (2025-12-26)
 */

import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@shared/config/query-client';
import { useMediaQuery } from '@shared/lib/hooks';

interface QueryProviderProps {
  children: ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  const showDevtools = useMediaQuery('(min-width: 360px)');

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* TanStack Query DevTools - only visible in development */}
      {import.meta.env.DEV && showDevtools && (
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
      )}
    </QueryClientProvider>
  );
}
